export default __webpack_public_path__ + "static/media/discord.b25ea51c.svg";